import OModalItemTileInfo from './o-modal-item-tile-info.vue';

export default OModalItemTileInfo;